import Notify from './Notify.vue'

const NotifyPlugin = {
  install(Vue) {

    this.EventBus = new Vue()

    Vue.component('app-notify', Notify)

    Vue.prototype.$notify = {
      showDuration(position, duration, msg) {
        NotifyPlugin.EventBus.$emit('showDuration', { position, duration, msg })
      },
      showInfinite(position, msg) {
        NotifyPlugin.EventBus.$emit('showInfinite', { position, msg })
      }
    }
  }
}

export default NotifyPlugin